import { render, staticRenderFns } from "./ClazzTab.vue?vue&type=template&id=0f64e42c&scoped=true&"
import script from "./ClazzTab.vue?vue&type=script&lang=js&"
export * from "./ClazzTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f64e42c",
  null
  
)

export default component.exports